// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer__footer--2Jr2G4u_YX31Aro6dXM6Oa","footerLabel":"Footer__footer__label--1Ov6Zy_QNLng7d_TzO7Dab","footerContainer":"Footer__footer-container--3USUeTJjU_MP4F0KT04d4z"};